module.exports = __webpack_public_path__ + "img/services.5ff3b186.svg";